import ReactDom from 'react-dom';

import { useContext } from 'react';

import { CustomStatusContext } from '../../CustomStatus.query';
import { DeleteEquipmentStatusQuery } from './DeleteEquipmentStatus.query';

import { Overlay, Container } from './DeleteEquipmentStatus.styles';

const DeleteEquipmentStatus = () => {
  const { openDelete } = useContext(CustomStatusContext);

  const portalDiv = document.getElementById('portal');

  return openDelete.get() && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <DeleteEquipmentStatusQuery />
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};

export { DeleteEquipmentStatus };
